'use client';

import { Label as LabelPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';

import { cn } from '@platform/ui/lib/utils';

/** A field's visible name: above the control, 13px, graphite — never a placeholder's job. */
export function Label({ className, ...props }: ComponentProps<typeof LabelPrimitive.Root>) {
    return <LabelPrimitive.Root data-slot="label" className={cn('text-13 font-medium text-foreground select-none', className)} {...props} />;
}
